export default __webpack_public_path__ + "static/qa-test-cover-f1debba7bc76f1f3764b9617404d0bca.png";